import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useRef, useState } from 'react';
import InventoryContext from '~/context/srp/InventoryContext';

// Load Previous needs an announcement + focus target - it prepends
// above the fold and scrolls to top
export default function usePreviousResultsMessage(): string {
  const { loadMoreResultsTileInfo, previousResultsLoadedCount } =
    useContext(InventoryContext);
  const [previousResultsMessage, setPreviousResultsMessage] = useState('');

  const loadMoreResultsTileInfoDataRef = useRef(loadMoreResultsTileInfo.data);
  loadMoreResultsTileInfoDataRef.current = loadMoreResultsTileInfo.data;

  useSubsequentEffect(() => {
    const vehicleCount =
      loadMoreResultsTileInfoDataRef.current[0]?.vehicleCount ?? 0;

    setPreviousResultsMessage(
      `${vehicleCount.toLocaleString()} earlier results loaded`
    );

    const firstTile = document.querySelector<HTMLElement>(
      '#results-section [role="listitem"]'
    );

    if (firstTile) {
      if (!firstTile.hasAttribute('tabindex')) {
        firstTile.setAttribute('tabindex', '-1');
        firstTile.addEventListener(
          'blur',
          () => firstTile.removeAttribute('tabindex'),
          { once: true }
        );
      }
      firstTile.focus();
    }
  }, [previousResultsLoadedCount]);

  return previousResultsMessage;
}
